// Shared by the interactive page and its build-time public HTML preview.
// Keep this explanation useful before JavaScript loads; never include user input.
export default function PublicSummary() {
  return (
    <div className="max-w-[720px] text-[15px] leading-[1.7] text-ink-mute mb-6">
      <p>
        Pressure Test is a free organisation design self-assessment by Sagentivum.
        Place your role in the Intelligence Tier model, describe your organisation
        and receive an AI-generated diagnosis with alternative design lenses.
      </p>
      <p className="mt-2">
        <a
          href="https://www.sagentivum.com/pressure-test/"
          className="text-green-700 underline decoration-green-700/40 hover:decoration-green-700"
        >
          How Pressure Test works and when to use it
        </a>
      </p>
    </div>
  );
}
